import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button, TextInput } from "@/components";

const planDetailsSchema = yup.object({
  name: yup.string().trim().required("Plan name is required"),
  description: yup.string().trim(),
});

type PlanDetailsFormData = {
  name: string;
  description: string;
};

interface PlanDetailsStepProps {
  initialName?: string;
  initialDescription?: string;
  onNext: (details: { name: string; description?: string }) => void;
  onBack: () => void;
}

export const PlanDetailsStep: React.FC<PlanDetailsStepProps> = ({
  initialName = "",
  initialDescription = "",
  onNext,
  onBack,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PlanDetailsFormData>({
    resolver: yupResolver(planDetailsSchema) as any,
    defaultValues: {
      name: initialName,
      description: initialDescription,
    },
  });

  const onFormSubmit = (data: PlanDetailsFormData) => {
    onNext({
      name: data.name.trim(),
      description: data.description?.trim() || undefined,
    });
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className="space-y-6">
      <div className="space-y-4">
        <TextInput
          label="Plan name"
          placeholder="e.g. Q1 Social Plan"
          error={!!errors.name}
          helperText={errors.name?.message}
          {...register("name")}
        />
        <TextInput
          label="Description (optional)"
          placeholder="Brief description of this plan"
          {...register("description")}
        />
      </div>

      <div className="flex gap-4 justify-between pt-4">
        <Button type="button" variant="outline" onClick={onBack}>
          Back
        </Button>
        <Button type="submit">Next</Button>
      </div>
    </form>
  );
};
